export default {
  venue: (state) => state.venue,
  venues: (state) => state.venues,
  layers: (state) => state.layers,
  venue_configs: (state) => state.venue_configs,
  edit_venue_configs: (state) => state.edit_venue_configs,
  tableOptions: (state) => state.tableOptions,
  new_config_venue: (state) => state.new_config_venue,
  invalid_image: (state) => state.invalid_image
}
